/* External */
import { initNavigation, setKeyMap } from '@noriginmedia/react-spatial-navigation';

/* Utils */
import platform from './platform';

export const Direction = {
  RIGHT: 'right',
  UP: 'up',
  DOWN: 'down',
  LEFT: 'left',
};

export function initSpatialNavigation() {
  initNavigation({
    debug: false,
    visualDebug: false,
  });
  setKeyMap(platform.keyCodes.navigation);
}

function preventDefaultArrowPress(forDirection) {
  return (direction) => direction !== forDirection;
}

export const preventDefaultLeftArrowPress = preventDefaultArrowPress(Direction.LEFT);
export const preventDefaultRightArrowPress = preventDefaultArrowPress(Direction.RIGHT);
export const preventDefaultUpArrowPress = preventDefaultArrowPress(Direction.UP);
export const preventDefaultDownArrowPress = preventDefaultArrowPress(Direction.DOWN);
